'use client'

import React, { ForwardedRef, useState } from 'react'
import Slider, { Settings as SliderProps } from 'react-slick'
import { cn } from '@admin/lib/utils'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import { NextArrow, PrevArrow } from './CarouselArrows'

interface CarouselProps extends SliderProps {
  items?: any[]
  // Updated to provide visibility context to children
  renderCarouselItem: (
    item: any,
    meta: { index: number; activeIndex: number; slidesToShow: number },
  ) => JSX.Element
  prevArrowClass?: string
  nextArrowClass?: string
  data: any
}

const Carousel = (
  {
    items,
    className,
    prevArrowClass = '',
    nextArrowClass = '',
    renderCarouselItem,
    appendDots,
    customPaging,
    children,
    data,
    ...restProps
  }: CarouselProps,
  ref: ForwardedRef<Slider>,
) => {
  const [activeIndex, setActiveIndex] = useState(0)
  const transitionDuration = 400

  const infinite = restProps.infinite ?? true

  const sliderDefaultProps = {
    dots: true,
    infinite,
    autoplay: true,
    autoplaySpeed: 3000,
    speed: transitionDuration,
    pauseOnFocus: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    nextArrow: <NextArrow nextArrowClass={nextArrowClass} infinite={infinite} />,
    prevArrow: <PrevArrow prevArrowClass={prevArrowClass} infinite={infinite} />,
    swipeToSlide: true,
  }

  return (
    <Slider
      ref={ref}
      {...sliderDefaultProps}
      // react-slick beforeChange provides (current, next). We must use 'next' to keep
      // activeIndex in sync; previously we captured the current index, causing the
      // last (or first) visible slide to be treated as hidden after navigating.
      beforeChange={(current, next) => {
        setActiveIndex(next)
      }}
      className={cn(!data?.ismlp ? 'pb-4' : 'pb-0', className)}
      {...restProps}
    >
      {items?.map((item, index) =>
        renderCarouselItem(item, {
          index,
          activeIndex,
          slidesToShow: restProps.slidesToShow || sliderDefaultProps.slidesToShow,
        }),
      )}
    </Slider>
  )
}

export default React.forwardRef(Carousel)
